//
//
//
//
//
//
//
//
//
//
//
//
//
//

  export default {
    name: "verificationCode",
    data() {
      return {
        code: "",
        codeText: "60s后重发",
        isSend: true,
        interval: null,
        time: 60,
        isAgainSend: true,
      };
    },
    props: {
      projectId: {
        type: String,
        default: '',
      },
      productId: {
        type: String,
        default: '',
      },
      productCode: {
        type: String | Number,
        default: '',
      },
      taskType: {
        type: String,
        default: ''
      },
      initSend: {
        type: Boolean,
        default: false,
      }
    },
    created() {
      //this.requestCode();
    },
    watch: {
      initSend: function (val) {
        // 已取消前端发送短信，打开弹窗不再自动触发 requestCode
      }
    },
    methods: {
      requestCode() {
        //请求短信验证码
        const $this = this
        const projectId = this.$props.projectId
        const openId = window.sessionStorage.getItem('openId')
        const taskType = this.$props.taskType;
        const url = "/wechat/sendValidCode.do";
        this.$axios({
          method: "post",
          url: url,
          data: {
            projectId: projectId,
            openId: openId,
            taskType: taskType
          }
        }).then(response => {
          if (response.data.code === 200) {
            $this.codeText = $this.time + "s后重发";
            $this.isSend = true;
            $this.isAgainSend = false;
            $this.interval = setInterval(() => {
              $this.time--;
              $this.codeText = $this.time + "s后重发";
              if ($this.time <= 1) {
                $this.codeText = "重新获取";
                $this.time = 60;
                $this.isSend = false;
                $this.isAgainSend = true;
                clearInterval($this.interval)
              }
            }, 1000);
          } else {
            $this.codeText = "重新获取";
            $this.time = 60;
            $this.isSend = false
            //$this.$vux.toast.text(response.data.message)
          }
        });
      },
      //验证短信验证码
      verifyCode() {
        const $this = this
        const verifyCode = this.code
        const projectId = this.$props.projectId
        const openId = window.sessionStorage.getItem('openId')
        const productId = this.$props.productId
        const productCode = this.$props.productCode
        const taskType = this.$props.taskType;

        // 已取消短信验证码，后端直接判定通过，此处不再强制要求输入验证码
        const url = "/wechat/validCode.do";
        this.$axios({
          method: "post",
          url: url,
          data: {
            verifyCode: verifyCode,
            projectId: projectId,
            openId: openId,
            taskType: taskType,
          }
        }).then(response => {
          if (response.data.code === 200) {
            const {erCode, verifycode, bucket, key, token, operate, url: uploadUrl} = response.data.result;//erCode=0成功
            // operate=1是以前的人脸识别，（保留原来页面）=2是视频活体检测 3是H5跳转检测
            if (erCode == 0) {
              if (operate == 1 || operate == 0) {
                $this.$router.push({
                  name: 'faceRecognition',
                  query: {projectId: projectId, productId: productId, productCode: productCode, taskType: taskType}
                })
              } else if (operate == 2 || operate == 3) {
                //页面定位
                window.sessionStorage.setItem("pagePositioning", "pagePositioning");
                if (operate == 2) {
                  localStorage.setItem('uploadUrl', uploadUrl);
                }
                //verifycode,四位数验证码（用于人脸识别页面 bucket,key,token 视频上传需要的token
                $this.$router.push({
                  name: 'livefaceRecognition',
                  query: {projectId, productId, productCode, taskType, verifycode, bucket, key, token, operate}
                })
              } else {
                this.$vux.toast.text(response.data.result.erMsg);
              }
            } else {
              this.$vux.toast.text(response.data.result.erMsg);
            }
          } else {
            //this.$vux.toast.text(response.data.message);
          }
        });
      }
    }
  };



// WEBPACK FOOTER //
// ./src/pages/agreement/verificationCode.vue